/**
 * Shared constants for @sailfish-ai/autofix
 */

import { homedir } from "os";
import { join } from "path";

// Credentials
export const SAILFISH_DIR = join(homedir(), ".sailfish");
export const CREDENTIALS_FILE = join(SAILFISH_DIR, "credentials.json");
export const CREDENTIALS_MODE = 0o600;

// Auth
export const SAILFISH_AUTH_URL = process.env.SAILFISH_AUTH_URL || "https://app.sailfish.ai/auth/cli";
// Must match the URL the web auth flow hands out (CLIAuth.tsx): api.sailfish.ai
// has no DNS record, and the trailing slash avoids a 301 that would turn the
// GraphQL POST into a GET.
export const SAILFISH_GRAPHQL_URL = process.env.SAILFISH_GRAPHQL_URL || "https://ui-api.sailfish.ai/graphql/";

// Skill
export const SKILL_DIR_NAME = "sailfish-autofix";
export const CROSS_CLIENT_SKILLS_DIR = ".agents/skills";

// MCP
export const MCP_SERVER_NAME = "sailfishAutofix";
export const MCP_SERVE_COMMAND = "npx";
export const MCP_SERVE_ARGS = ["@sailfish-ai/autofix", "serve"];

// Package
export const PACKAGE_NAME = "@sailfish-ai/autofix";
